import Cookies from 'js-cookie'
import Helpers from './Helpers'
import Shortlist from './Shortlist.js'
import XHRPromise from 'xhr-promise'
import he from 'he'

const LOCALSTORAGE_SHORTLIST_KEY = 'shortlists'

class Shortlistitem {
    constructor(item = null) {
        if (item != null) {
            this.value = item.value
            this.id = item.id
            this.shortlistId = item.shortlistId
            // this.created = item.created
        }
    }
}

class ShortlistNew {
    constructor(shortlist = null) {
        this.name = ''
        this.public = false
        this.id = ''
        // this.created = ''
        this.items = []
        if (shortlist != null) {
            this.populate(shortlist)
        }
    }

    populate(shortlist) {
        this.name = shortlist.name
        this.public = shortlist.public
        this.id = shortlist.id
        // this.created = shortlist.created
        shortlist.items.forEach((item) => {
            this.items.push(new Shortlistitem(item))
        })
    }
    addItem(value) {
        const item = new Shortlistitem()
        item.value = value
        this.items.push(item)
    }
}

class ShortlistAPI {
    constructor() {
        this.baseURL = '/api'
        this.getAllUrl = `${this.baseURL}/shortlists`
        this.shortlists = []
        this.shortListItems = []

        if (!this.userIsAuthenticated()) {
            window.localStorage.removeItem(LOCALSTORAGE_SHORTLIST_KEY)
        }
        this.GetAllFromLocalStorage()
    }

    userIsAuthenticated() {
        return typeof Cookies.get('auth') !== 'undefined'
    }

    token() {
        return Cookies.get('auth')
    }

    LoadShortlists(forceRefresh = false) {
        return new Promise((resolve) => {
            if (this.userIsAuthenticated()) {
                if (window.localStorage.getItem(LOCALSTORAGE_SHORTLIST_KEY) === null || forceRefresh) {
                    this.GetAllshortlists().then(() => {
                        this.GetAllFromLocalStorage()
                        resolve()
                    })
                }
            }
            resolve()
        })
        
    }

    UpdateLocalStorage(Lsshortlists) {
        const obj = JSON.stringify(Lsshortlists)
        window.localStorage.setItem(LOCALSTORAGE_SHORTLIST_KEY, obj)
        this.updateListOfShortlists()
    }

    GetAllFromLocalStorage() {
        this.shortlists = []
        if (window.localStorage.getItem(LOCALSTORAGE_SHORTLIST_KEY) !== null) {
            try {
                const obj = JSON.parse(window.localStorage.getItem(LOCALSTORAGE_SHORTLIST_KEY))
                if (obj.length > 0) {
                    obj.forEach(sl => this.shortlists.push(new ShortlistNew(sl)))
                }
            }
            catch(err) {
                window.localStorage.removeItem(LOCALSTORAGE_SHORTLIST_KEY)
            }
        }
    }

    GetAllshortlists() {
        return new Promise((resolve) => {
            if (this.userIsAuthenticated()) {
                const GetAllRequest = new XHRPromise()
                GetAllRequest.send({
                    url: this.getAllUrl,
                    headers: { Authorization: `Bearer ${this.token()}` },
                }).then((response) => {
                    this.shortlists = []
                    if (response.responseText.length) {
                        response.responseText.forEach((shortlist) => {
                            this.shortlists.push(new ShortlistNew(shortlist))
                        })
                    }
                    this.UpdateLocalStorage(this.shortlists)
                    this.updateHeaderIcon()
                    resolve()
                })
            }

        })
    }

    CreateShortlist(Slname, SlPublic) {
        const PostShortList = new XHRPromise()
        const obj = JSON.stringify({ name: Slname, public: SlPublic })
        return new Promise((resolve) => {
            PostShortList.send({
                method: 'POST',
                url: this.getAllUrl,
                headers: { Authorization: `Bearer ${this.token()}`, 'Content-Type': 'application/json' },
                data: obj,
            }).then(() => {
                this.GetAllshortlists().then(() => resolve())
            })
        })
    }

    PatchShortlist(SlName, SlGuid) {
        const PatchShortList = new XHRPromise()
        const obj = JSON.stringify({ name: SlName })
        const patchURL = `${this.getAllUrl}/${SlGuid}/`
        return new Promise((resolve) => {
            PatchShortList.send({
                method: 'PATCH',
                url: patchURL,
                headers: { Authorization: `Bearer ${this.token()}`, 'Content-Type': 'application/json' },
                data: obj,
            }).then(() => {
                this.GetAllshortlists().then(() => resolve())
            })
        })
    }

    AddShortlistItem(item) {
        const shortlist = this.shortlists.find(s => s.id === item.shortlistId)
        let matchedItem = 'undefined'
        if (typeof shortlist.items !== 'undefined') {
            matchedItem = shortlist.items.find(i => i.value === item.value)
        }
        if (typeof matchedItem === 'undefined' || matchedItem === '') {
            const PostShortListItem = new XHRPromise()
            const obj = JSON.stringify({ value: item.value })
            const postItemUrl = `${this.getAllUrl}/${item.shortlistId}/items`
            PostShortListItem.send({
                method: 'POST',
                url: postItemUrl,
                headers: { Authorization: `Bearer ${this.token()}`, 'Content-Type': 'application/json' },
                data: obj,
            }).then(() => {
                this.GetAllshortlists()
                this.updateListOfShortlists()
            })
        }
    }

    DeleteShortlist(listId) {
        if (typeof listId !== 'undefined') {
            const DeleteShortList = new XHRPromise()
            const deleteUrl = `${this.getAllUrl}/${listId}`
            return new Promise((resolve) => {
                DeleteShortList.send({
                    method: 'DELETE',
                    url: deleteUrl,
                    headers: { Authorization: `Bearer ${this.token()}`, 'Content-Type': 'application/json' },
                }).then(() => {
                    this.GetAllshortlists().then(() => resolve())
                })
            })
        }
    }

    DeleteShortListItem(item) {
        const shortlist = this.shortlists.find(s => s.id === item.shortlistId)
        const matchedItem = shortlist.items.find(i => i.value === item.value)
        if (typeof matchedItem !== 'undefined') {
            const DeleteShortListItem = new XHRPromise()
            const deleteItemUrl = `${this.getAllUrl}/${item.shortlistId}/items/${item.id}`
            DeleteShortListItem.send({
                method: 'DELETE',
                url: deleteItemUrl,
                headers: { Authorization: `Bearer ${this.token()}`, 'Content-Type': 'application/json' },
            }).then(() => {
                this.GetAllshortlists()
            })
        }
    }

    DeleteCottageFromShortListMultiList(cottageCode, ListId) {
        this.DeleteCottageFromShortList(cottageCode, ListId)
        const container = event.target.closest('div')
        const p = container.querySelector('p')
        p.setAttribute('data-inlist', 'false')
        container.setAttribute('data-active', 'false')
        let dataactive = false
        const items = container.parentElement.querySelectorAll('p')
        items.forEach((i) => {
            if (i.getAttribute('data-inlist') === 'true') {
                dataactive = true
            }
        })
        new Helpers(document.querySelectorAll(`.favourite-button[data-code="${cottageCode}"]`)).setAttributes({ 'data-active': dataactive })
        document.getElementsByTagName('body')[0].dispatchEvent(new CustomEvent('shortlist.remove'))
        this.updateListOfShortlists()
    }

    ChangeSetValueMulti() {
        const multiListItem = new Helpers(event.target).getClosest('p')
        let inList = multiListItem.getAttribute('data-inlist')
        const cottageCode = multiListItem.getAttribute('data-code')
        const listId = multiListItem.getAttribute('data-guid')
        if (inList === '') { inList = false }
        if (inList !== 'true') {
            this.AddCottageToShortListMultiList(cottageCode, listId)
        } else {
            this.DeleteCottageFromShortListMultiList(cottageCode, listId)
        }
    }
    DeleteCottageFromShortList(cottageCode, ListId) {
        this.GetAllFromLocalStorage()
        let sl = ''
        if (this.shortlists.find(i => i.id === ListId)) {
            sl = this.shortlists.find(i => i.id === ListId)
        }
        if (sl.items.length) {
            const thisItem = sl.items.find(i => i.value === cottageCode)
            thisItem.shortlistId = sl.id
            this.DeleteShortListItem(thisItem)
        }
    }
    AddCottageToShortListMultiList(cottageCode, ListId) {
        this.AddCottageToShortList(cottageCode, ListId)
        const container = event.target.closest('div')
        container.setAttribute('data-active', 'true')
        new Helpers(document.querySelectorAll(`.favourite-button[data-code="${cottageCode}"]`)).setAttributes({ 'data-active': 'true' })
        const p = container.querySelector('p')
        p.setAttribute('data-inlist', 'true')
    }

    AddCottageToShortList(cottageCode, ListId) {
        this.GetAllFromLocalStorage()
        let sl = ''
        if (this.shortlists.find(i => i.id === ListId)) {
            sl = this.shortlists.find(i => i.id === ListId)
        }
        const thisItem = new Shortlistitem()
        if (typeof sl === 'undefined' || sl === '') {
            this.CreateShortlist('Default', false).then(() => {
                thisItem.shortlistId = window.sl.shortlists[0].id
                thisItem.value = cottageCode
                this.AddShortlistItem(thisItem)
            })
        } else {
            thisItem.shortlistId = sl.id
            thisItem.value = cottageCode
            this.AddShortlistItem(thisItem)
        }
    }

    updateHeaderIcon() {
        const highlightClass = 'header__favourites--active'
        const cookieName = 'CC_SHLC'
        const icon = document.getElementsByClassName('header__favourites')

        Cookies.remove(cookieName)

        if (this.userIsAuthenticated()) {
            this.GetAllFromLocalStorage()
            if (typeof this.shortlists !== 'undefined') {
                if (this.shortlists.length) {
                    let shortlistsItemsCount = 0
                    this.shortlists.forEach((sl) => shortlistsItemsCount += sl.items.length)

                    if (shortlistsItemsCount > 0) {
                        new Helpers(icon).addClass(highlightClass)
                        Cookies.set(cookieName, shortlistsItemsCount)
                    } else {
                        new Helpers(icon).removeClass(highlightClass)
                    }
                }
            }
        } else {
            const shortlist = Cookies.get('shortlist')
            if (typeof shortlist !== 'undefined' && shortlist.length > 0) {
                new Helpers(icon).addClass(highlightClass)
            } else {
                new Helpers(icon).removeClass(highlightClass)
            }
        }
    }

    HighlightShortlistedCottages() {
        const buttons = document.getElementsByClassName('favourite-button')
        if (this.userIsAuthenticated()) {
            if (typeof this.shortlists === 'undefined') {
                this.GetAllshortlists().then(() => {
                    this.HighlightShortlistedCottages()
                })
                return
            }
            new Helpers(buttons).setAttributes({ 'data-multi': 'true' })
        } else {
            new Helpers(buttons).setAttributes({ 'data-multi': 'false' })
        }
        
        Array.from(buttons).forEach((button) => {
            const val = this.IsCodeInShortlists(button.getAttribute('data-code'))
            button.setAttribute('data-active', val)
        })
    }

    updateListOfShortlists() {
        const shortlistLinks = document.querySelector('.shortlist-list ul')
        if (shortlistLinks !== null) {
            // empty items from div
            shortlistLinks.innerHTML = ''
            // repopulate div
            const currentId = document.getElementById('listId').value
            this.shortlists.forEach((s) => {
                let activeFlag = ''
                if (currentId === s.id) {
                    activeFlag = 'aria-current="true"'
                }
                shortlistLinks.innerHTML += `<li class="shortlists-item" ${activeFlag} data-shortlistid="${s.id}"><a href="/my-classic/MyShortlist.aspx?id=${s.id}"><span class="shortlist-name">${s.name}</span> <span class="shortlist-count">${s.items.length}</span></a></li>`
            })
        }
    }

    IsCodeInShortlists(code) {
        let found = 'false'
        if (this.userIsAuthenticated()) {
            this.GetAllFromLocalStorage()
            this.shortlists.forEach((sl) => {
                if (sl.items.find(i => i.value === code)) {
                    found = 'true'
                }
            })
        } else {
            const shortlist = new Shortlist()
            if (shortlist.contains(code)) {
                found = 'true'
            }
        }
        return found
    }
}

const favouriteButtons = document.querySelectorAll('.favourite-button')

new Helpers(document.getElementsByTagName('body')).delegateEventListener('.modal-open[aria-controls="createShortlist"]', (e) => {
    const modal = document.getElementById('createShortlist')
    modal.setAttribute('data-code', new Helpers(e.target).getClosest('.modal-open').getAttribute('data-code'))
}, 'click')

new Helpers(document.querySelector('.modal-open[aria-controls="EditShortlist"]')).eventListener((e) => {
    const guid = e.target.getAttribute('data-slguid')
    const Sl = window.sl.shortlists.find(s => s.id === guid)
    document.getElementsByClassName('edit-shortlist-name')[0].value = he.decode(Sl.name)
    document.getElementsByClassName('edit-shortlist-name')[0].setAttribute('data-slguid', guid)
}, 'click')

new Helpers(window).eventListener(() => {
    window.sl = new ShortlistAPI()
    const forceRefresh = document.querySelectorAll('.shortlist__lead, .cottage').length > 0
    window.sl.updateHeaderIcon()
    window.sl.LoadShortlists(forceRefresh).then(() => {
        window.sl.HighlightShortlistedCottages()
        window.sl.updateHeaderIcon()

        
        if (window.sl.userIsAuthenticated()) {
            Array.from(favouriteButtons).forEach((el) => {
                el.setAttribute('data-multi', 'true')
                el.setAttribute('data-active', window.sl.IsCodeInShortlists(el.getAttribute('data-code').replace(/[CX]/, '')))
            })
        }


    })
}, 'load')

new Helpers(document.querySelector('.shortlist-aside__select select')).eventListener((e) => {
    const shortlistId = e.target.value
    window.location = `/my-classic/MyShortlist.aspx?id=${shortlistId}`
}, 'change')

new Helpers(document.querySelector('.shortlist__consent--append-to-list')).eventListener(() => {
    const codes = document.querySelector('.urlshortlistCodes').value.split(',')
    const selector = document.querySelector('#ShortlistsConsent')
    const guid = selector[selector.selectedIndex].value
    const shortlist = window.sl.shortlists.find(s => s.id === guid)
    codes.forEach((c) => {
        const thisItem = new Shortlistitem()
        thisItem.shortlistId = shortlist.id
        thisItem.value = c
        window.sl.AddShortlistItem(thisItem)
    })
    window.location = `/my-classic/MyShortlist.aspx?id=${guid}`
}, 'click')

new Helpers(document.querySelector('.shortlist__consent--create-new')).eventListener(() => {
    const url = `${window.location.href}&SaveSharedShortlist=true`
    window.location = url
}, 'click')

new Helpers(document.querySelector('.shortlist__consent .close')).eventListener(() => {
    document.querySelector('.shortlist__consent').hidden = true
}, 'click')

const modal = document.getElementById('createShortlist')
if (modal !== null) {
    const formUI = document.getElementsByClassName('modal-create-shortlist__form')[0]
    const successUI = document.getElementsByClassName('modal-shortlist__success')[0]
    const errorUI = document.getElementsByClassName('modal-shortlist__error')[0]
    new Helpers(formUI.getElementsByClassName('shortlist-create')[0]).eventListener((e) => {
        const cottageCode = modal.getAttribute('data-code')
        const name = formUI.getElementsByClassName('shortlist-name')[0].value
        e.preventDefault()
        if (name.length > 0) {
            window.sl.CreateShortlist(name, false).then(() => {
                const thisId = window.sl.shortlists[window.sl.shortlists.length - 1].id
                if (cottageCode !== 'null') {
                    const thisItem = new Shortlistitem()
                    thisItem.shortlistId = thisId
                    thisItem.value = cottageCode
                    window.sl.AddShortlistItem(thisItem)
                    new Helpers(document.querySelectorAll(`.favourite-button[data-code="${cottageCode}"]`)).setAttributes({ 'data-active': 'true' })
                }
                formUI.setAttribute('aria-hidden', 'true')
                errorUI.setAttribute('aria-hidden', 'true')
                successUI.setAttribute('aria-hidden', 'false')

                if (document.getElementsByClassName('shortlist-home').length) {
                    setTimeout(() => {
                        modal.querySelector('.modal-close').click()
                    }, 1000)
                    window.location.href = `/my-classic/MyShortlist.aspx?id=${thisId}`
                } else {
                    setTimeout(() => {
                        modal.querySelector('.modal-close').click()
                        errorUI.setAttribute('aria-hidden', 'true')
                        successUI.setAttribute('aria-hidden', 'true')
                        formUI.setAttribute('aria-hidden', 'false')
                        formUI.getElementsByClassName('shortlist-name')[0].value = ''
                    }, 2000)
                }
            })
        }
    })
}
const EditModal = document.getElementById('EditShortlist')
if (EditModal !== null) {
    const formUI = document.getElementsByClassName('modal-edit-shortlist__form')[0]
    const successUI = document.getElementsByClassName('modal-edit-shortlist__success')[0]
    const errorUI = document.getElementsByClassName('modal-edit-shortlist__error')[0]
    new Helpers(formUI.getElementsByClassName('shortlist-edit')[0]).eventListener((e) => {
        const guid = document.getElementsByClassName('edit-shortlist-name')[0].getAttribute('data-slguid')
        const name = formUI.getElementsByClassName('edit-shortlist-name')[0].value
        e.preventDefault()
        if (name.length > 0) {
            window.sl.PatchShortlist(name, guid).then(() => {
                formUI.setAttribute('aria-hidden', 'true')
                errorUI.setAttribute('aria-hidden', 'true')
                successUI.setAttribute('aria-hidden', 'false')

                if (document.getElementsByClassName('shortlist-home').length) {
                    setTimeout(() => {
                        modal.querySelector('.modal-close').click()
                    }, 1000)
                    window.location.href = `/my-classic/MyShortlist.aspx?id=${guid}`
                }
            })
        }
    })
}


